module.exports = __webpack_public_path__ + "static/img/logo-card-blue.71cef61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/game/logo-card-blue.svg
// module id = 742
// module chunks = 2 3 4 5 12